import noop from 'lodash/noop';

import { MIN_SCROLL, CAPACITY_RESERVE, PAGINATOR_BUTTON_VIEW } from '../paginator.constants';
import { Page } from '../types';

const getPageText = (page: Page) => (page.number + 1).toString();

const getPageWithText = (page: Page) => {
    return { ...page, text: getPageText(page) };
};

const getFirstPage = (pages: Page[], goToFirstPage: (pages: Page[]) => void) => {
    const protoPage = pages[0];

    return {
        ...protoPage,
        onClick: () => goToFirstPage(pages),
        text: getPageText(protoPage),
    };
};

const getLastPage = (pages: Page[], goToLastPage: (pages: Page[]) => void) => {
    const protoPage = pages[pages.length - 1];

    return {
        ...protoPage,
        onClick: () => goToLastPage(pages),
        text: getPageText(protoPage),
    };
};

export const pageMapper = (
    pages: Page[],
    scroll: number,
    goToFirstPage: (pages: Page[]) => void,
    goToLastPage: (pages: Page[]) => void,
    paginatorCapacity: number
    // eslint-disable-next-line max-params
) => {
    const capacitySufficient = pages.length <= paginatorCapacity;

    if (capacitySufficient) {
        return pages.map(getPageWithText);
    }
    // else need scroll

    const ellipsis = {
        text: '...',
        disabled: true,
        number: NaN,
        selected: false,
        onClick: noop,
        view: PAGINATOR_BUTTON_VIEW.DEFAULT,
    };

    const firstPage = getFirstPage(pages, goToFirstPage);
    const lastPage = getLastPage(pages, goToLastPage);
    const scrolledToTop = scroll === MIN_SCROLL;

    if (scrolledToTop) {
        const visiblePages = pages.slice(0, paginatorCapacity - CAPACITY_RESERVE).map((page) => ({
            ...page,
            text: (page.number + 1).toString(),
        }));

        visiblePages.push(ellipsis, lastPage);

        return visiblePages;
    }

    const scrolledToBottom = scroll === pages.length - paginatorCapacity + CAPACITY_RESERVE;

    if (scrolledToBottom) {
        const visiblePages = pages
            .slice(pages.length - paginatorCapacity + CAPACITY_RESERVE, pages.length)
            .map((page) => ({
                ...page,
                text: (page.number + 1).toString(),
            }));

        visiblePages.unshift(firstPage, ellipsis);

        return visiblePages;
    }

    const capacityWithDoubleEllipsis = paginatorCapacity - 2 * CAPACITY_RESERVE;
    const visiblePages = pages.slice(scroll, scroll + capacityWithDoubleEllipsis).map(getPageWithText);
    visiblePages.push(ellipsis, lastPage);
    visiblePages.unshift(firstPage, ellipsis);

    return visiblePages;
};
